<template>
    <div
        :class="[
            'hidden-print-only',
            'loading-dummy',
            {'loading-dummy-hidden':visible}
        ]"
        :style="style"
    >
        <div
            v-for="(row,rowIndex) in itemsPerRow"
            :key="rowIndex"
            class="loading-dummy-row"
        >
            <div
                v-for="(item,index) in row"
                :key="'item_'+index"
                :style="`width:${item.width};height:${item.height};background:${item.background}`"
                :class="{'loading-dummy-item-hidden':!item.visible}"
                class="loading-dummy-item"
            >
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
import appColors from '@/assets/js/src/style/json/colors'

export default {
    name: 'LoadingDummy',
    props: {
        /** Array der abzubildenden Struktur
             *
             * itemsPerRow[row][item] = size
             *
             * **/
        itemsPerRow: {
            type: Array,
            default: () => ([
                [
                    {
                        height: '40px',
                        width: '40px',
                        margin: '',
                        background: appColors.greyLight,
                        visible: true,
                    },
                ],
            ]),
        },
        rowStyle: {
            type: String,
            default: '',
        },
    },
    computed: {
        style () {
            if (this.itemsPerRow.length === 1) {
                return `flex-grow:0!important;height:${this.itemsPerRow[0][0].height};width:${this.itemsPerRow[0][0].width};margin:${this.itemsPerRow[0][0].margin}`
            } else {
                return ''
            }
        },
        visible () {
            return this.itemsPerRow.some(row => row.some(item => !item.visible))
        },
    },
}
</script>

<style lang="scss" scoped>
    .loading-dummy {
        position: relative;
        overflow: hidden;

        &::before {
            position: absolute;
            inset: 0 0 0 50%;
            z-index: 1;
            width: 500%;
            height: 100%;
            margin-left: -250%;
            background: linear-gradient(to right, rgb(255 255 255 / 0%) 46%, rgb(255 255 255 / 35%) 50%, rgb(255 255 255 / 0%) 54%) 50% 50%;
            animation: loading .8s linear infinite;
            content: " ";

            @include dark {
                background: linear-gradient(to right, rgb(43 43 43 / 0%) 46%, rgb(43 43 43 / 35%) 50%, rgb(43 43 43 / 0%) 54%) 50% 50%;
            }
        }

        &-row {
            display: flex;
            justify-content: space-between;
            width: 100%;
            height: 100%;
        }

        &-hidden::before {
            opacity: 0;
            animation: none;
        }

        &-item-hidden {
            opacity: 0;
        }
    }

    @keyframes loading {
        0% {
            transform: translate3d(-30%, 0, 0);
        }

        100% {
            transform: translate3d(30%, 0, 0);
        }
    }
</style>
